/**
 * Project settings — segmented tabs (single source of truth for labels/ids).
 */
export const PROJECT_SETTINGS_SEGMENT_TABS = [
  { id: "general", label: "General" },
  { id: "workflow_status", label: "Workflow & status" },
  { id: "notification", label: "Notification" },
];
